import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

class FundHistoryService {
  // Get user's fund history
  getUserFundHistory() {
    const user = JSON.parse(localStorage.getItem('user'));
    const username = user ? user.username : '';
    return axios.get(config.api.fundhistory + '/user/' + username, {
      headers: authHeader()
    });
  }

  // Admin: Get all fund history
  getAllFundHistory() {
    return axios.get(config.api.fundhistory + '/admin/all', {
      headers: authHeader()
    });
  }

  // Admin: Add new fund record (optional)
  createFundRecord(data) {
    return axios.post(config.api.fundhistory + '/admin/create', data, {
      headers: authHeader()
    });
  }

  // Admin: Delete fund record
  deleteFundRecord(id) {
    return axios.delete(config.api.fundhistory + '/admin/delete/' + id, {
      headers: authHeader()
    });
  }
}

export default new FundHistoryService();